import { Button } from 'antd'
import { SyncOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyledDHSApprovalSubmissionContainer } from './DHSApprovalSubmission.styled'

// Mirrors the resolved trigger's shape. This renders inside the chart action bar, which antd Affix
// measures once on mount, so a differently sized fallback leaves the bar mis-placed until a scroll.
export const DHSApprovalSubmissionLoading: React.FC = React.memo(() => {
  const { t } = useTranslation('dhsApprovalSubmission')

  return (
    <StyledDHSApprovalSubmissionContainer>
      <Button type="primary" icon={<SyncOutlined spin />} disabled>
        {t('btn_get_approval')}&nbsp;
      </Button>
    </StyledDHSApprovalSubmissionContainer>
  )
})
